<template>
    <page>
        <module enable-flex ref="view">
            <m-search ref="search" @search="searchHandle">
                <c-form ref="searchForm">
                    <c-form-item type="input" label="订单号" name="order_number"></c-form-item>
                    <c-form-item type="input" label="买家" name="user_info" placeholder="买家昵称、手机号"></c-form-item>
                    <c-form-item type="input" label="商品名称" name="product_name" placeholder="模糊匹配"></c-form-item>
                    <c-form-item type="input" label="商品规格" name="product_sku_spec"
                                 placeholder="模糊匹配"></c-form-item>
                    <c-form-item type="input" label="SKU编码" name="product_sku_code"
                                 placeholder="精确匹配"></c-form-item>
                    <!-- <c-form-item type="input" label="收货信息" name="receiving_info"
                                 placeholder="收货人、电话、地址"></c-form-item>
                    <c-form-item type="input" label="运单号" name="logistics_number"
                                 placeholder="模糊匹配"></c-form-item> -->
                    <c-form-item type="datetime" label="下单时间" start-name="start_date"
                                 end-name="end_date"></c-form-item>
                    <c-form-item type="datetime" label="付款时间" start-name="pay_start_date"
                                 end-name="pay_end_date"></c-form-item>
                    <!-- <c-form-item type="checkbox" label="" name="order_type" :options="orderType"></c-form-item> -->
                    <c-form-item v-if="systemConfig.is_virtual_product == 'ON'" type="checkbox" label=""
                                 name="order_classify" :options="orderClassify"></c-form-item>
                    <c-form-item v-if="systemConfig.cash_pay == 'ON'" type="checkbox" label="审核状态"
                                 name="check_state" :options="checkState"></c-form-item>
                </c-form>
            </m-search>
            <m-operate>
                <c-button color="sys" power="b_cash_order_approve" @click="batchApproved(2)">批量审核通过</c-button>
                <c-button color="red" power="b_cash_order_approve" @click="batchApproved(3)">批量审核驳回</c-button>
<!--
                <c-button color="m" hollow @click="syncExport()">导出订单明细</c-button>
-->

<!--                <template #right>
                    <c-button v-if="userInfo.id == 1" color="red" @click="$refs.view.editExportColumn(workType)">编辑导出列</c-button>
                </template>-->
            </m-operate>
            <c-table ref="table">
                <c-table-column width="400">
                    <template slot="head">
                        <span style="margin-left: 15px;">商品信息</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="单价"
                        width="130"
                        align-center
                ></c-table-column>

                <c-table-column
                        label="数量"
                        width="130"
                        align-center
                ></c-table-column>

                <c-table-column
                        label="总金额"
                        width="170"
                        align-center
                ></c-table-column>

                <c-table-column
                        label="交易状态"
                        width="170"
                        align-center
                ></c-table-column>

                <c-table-column
                        label="操作"
                        width="170"
                        align-center
                ></c-table-column>

                <template #custom="{data}">
                    <div :key="data.order_number" class="order">
                        <div class="order-head flex-between-center">
                            <div class="flex-center">
                                <input v-if="data.check_state == 1" type="checkbox" :value="data.order_number" v-model="data.checked"/>
                                <div class="tag" v-if="data.check_state == 1" style="background:brown">待审核</div>
                                <div class="tag" v-if="data.check_state == 2" style="background:green">审核通过</div>
                                <div class="tag" v-if="data.check_state == 3" style="background:red">审核驳回</div>
                                <span class="number">
                                    订单号：
                                    <a style="color:blue;" @click="navigateTo(`/order_detail/${data.order_number}`)">
                                        {{data.order_number}}
                                    </a>
                                </span>
                                <div class="tag" v-if="data.order_type!=1" style="background: #4686e0">
                                    {{ orderTypeName[data.order_type] }}
                                </div>
                                <p class="info" v-if="systemConfig.pt_mode == 2">
                                    归属商家：{{ data.stationed_name }}
                                </p>
                                <p class="info">
                                    下单时间：{{ data.create_date }}
                                </p>
                                <p class="info" v-if="data.payment_state == 3 && data.payment_date">
                                    支付时间：{{ data.payment_date }}
                                </p>
                            </div>
                        </div>
                        <div class="order-head flex">
                            <span lass="number">买家：{{ data.nick_name || data.receiving_name }}（{{data.user_manage_mobilephone}}）</span>
                            <p class="info"
                               v-if="data.order_classify == 1 && data.receiving_name && data.receiving_phone && data.receiving_address">
                                收货信息：{{ data.receiving_name }}；{{ data.receiving_phone }}；{{
                                    data.receiving_address
                                }}
                            </p>
                            <div class="info flex flex-grow"
                                 v-if="data.order_classify == 1 && data.send_logistics_number_list && data.send_logistics_number_list.length > 0">
                                <p>发货物流：</p>
                                <div class="flex-grow flex-wrap">
                                    <template v-for="(item, i) in data.send_logistics_number_list">
                                        <p :key="i"
                                           style="max-width: 100%; word-break: break-all; white-space: normal;">
                                            <span>{{ item.logistics_company }}</span>
                                            <span v-if="item.logistics_number">({{
                                                    item.logistics_number || '--'
                                                }})</span>
                                        </p>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="flex">
                            <div class="order-product">
                                <div v-for="(sku, i) in data.product_sku_list" :key="i" class="sku flex-center">
                                    <div class="sku-info flex-center flex-grow">
                                        <c-image class="sku-image" :src="sku.product_img_url"></c-image>
                                        <div class="flex-grow">
                                            <p class="sku-name ellipsis">{{ sku.product_name }}</p>
                                            <p class="sku-sku">
                                                <a style="color:darkgray"
                                                   v-if="sku.product_sku_spec">规格：</a>{{ sku.product_sku_spec }}；
                                                <a style="color:darkgray"
                                                   v-if="sku.product_sku_code">SKU编码：</a>{{ sku.product_sku_code }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="sku-price">￥{{ sku.product_unit_price }}</div>
                                    <div class="sku-count">{{ sku.product_count }}</div>
                                </div>
                            </div>
                            <div class="order-sum flex-column flex-center">
								<span v-if="data.order_type==2">
									{{ data.points }}积分
                                    <span v-if="data.product_money && data.product_money > 0">
                                        + ￥{{ parseFloat(data.product_money).toFixed(2) }}
                                    </span>
								</span>
                                <span v-if="data.order_type==2 && data.logistics_money > 0">
									(另运费￥{{ parseFloat(data.logistics_money).toFixed(2) }})
								</span>
                                <span v-if="data.order_type!=2 && data.payment_state != 3">
									￥{{
                                        parseFloat(data.product_money + data.custom_money + data.logistics_money + data.total_fee_money).toFixed(2)
                                    }}
								</span>
                                <span v-if="data.order_type!=2 && data.payment_state == 3">
									￥{{ parseFloat(data.payment_money).toFixed(2) }}
								</span>
                                <span v-if="data.order_type!=2 && data.logistics_money > 0">
									(含运费￥{{ parseFloat(data.logistics_money).toFixed(2) }})
								</span>
                                <span v-if="data.order_type!=2 && data.total_fee_money > 0" style="color:orangered">
									(含服务费￥{{ parseFloat(data.total_fee_money).toFixed(2) }})
								</span>
                                <span v-if="data.order_type==7 && data.custom_money > 0" style="color:orangered">
									(含定制费￥{{ parseFloat(data.custom_money).toFixed(2) }})
								</span>
                            </div>
                            <div class="order-state flex-column flex-center">
                                <span v-if="data.check_state==1 && data.payment_type=='转账支付'" style="color:#182eff">待审核</span>
                                <span v-if="data.check_state==3" style="color:#ff5555">审核驳回</span>
                                <span v-if="data.check_state==2">
                                        <span v-if="data.order_type == 8 && data.group_achieve == 0">
                                           待成团
                                        </span>
                                        <span v-else>
                                            <span v-if="data.order_classify == 2 && data.order_state == 3">待使用</span>
                                            <span v-else>{{ orderStateName[data.order_state] }}</span>
                                            <span v-if="data.return_flag==1">(售后中)</span>
                                            <span v-else-if="data.refund_flag==1">(未发退款中)</span>
                                        </span>
								</span>
                                <span v-if="data.order_state == 3">(服务中)</span>
                                <a @click="navigateTo(`/retail_order/${data.order_number}`)">订单详情</a>
                            </div>
                            <div class="order-handle flex-column flex-center">
                                <c-button color="gray" hollow power="b_cash_order_approve"
                                          v-if="data.check_state==1 && data.order_state != 6" @click="navigateTo(`/retail_order/${data.order_number}`)">审批
                                </c-button>
                            </div>
                        </div>
                    </div>
                </template>
            </c-table>
        </module>
        <!--审核驳回原因弹框 -->
        <c-dialog ref="rejectReason" title="不通过原因" width="550" button-name="审核驳回" @resolve="rejectHandle">
            <div class="order-remark">
                <textarea v-model="rejectReason" placeholder="请输入不通过原因..."></textarea>
            </div>
        </c-dialog>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import productInfo from '@/components/public/product_info.vue'

export default {
    name: 'm_cash_order',

    // 第二步：定义组件，导入了哪些就定义哪些
    components: {
        productInfo,
    },

    props: {
    },

    data() {
        return {
            importWorkType: 901,
            workType: 14,
            orderStateName: {
                1: '待付款',
                2: '待发货',
                3: '待收货',
                5: '交易完结',
                6: '已关闭'
            },
            operationModeName: {
                1: '平台自营',
                2: '商家自营'
            },
            orderTypeName: {
                1: '普通',
                2: '积分',
                3: '升级赠品',
                4: '砍价',
                5: '预售订单(全款)',
                6: '预售订单(定金)',
                7: '定制',
                8: '拼团',
                9: '云仓提货',
                10: '送礼',
                11: '抽奖'
            },
            orderClassifyName: {
                1: '实物',
                2: '虚拟',
            },
            orderSourceName: {
                'OMS': '管理后台',
                'IOS': '苹果',
                'ANDROID': '安卓',
                'MINI': '小程序',
                'PC': 'PC电脑'
            },
            freightPaymentTypeName: {
                1: '运费先付',
                2: '运费到付'
            },
            orderState: [
                {name: '待付款', value: 1},
                {name: '待发货', value: 2},
                {name: '待收货/使用', value: 3},
                {name: '交易完结', value: 5},
                {name: '已关闭', value: 6}
            ],
            checkState: [
                {name: '待审核', value: 1},
                {name: '审核通过', value: 2},
                {name: '审核驳回', value: 3}
            ],
            invoiceStateName: {
                0: '无需开票',
                1: '未开票',
                2: '已开票'
            },
            pushState: [
                {name: '无需推送', value: 0},
                {name: '待推送', value: 1},
                {name: '已推送', value: 3}
            ],
            operationMode: [
                {name: '平台自营', value: 1},
                {name: '商家自营', value: 2}
            ],
            cloudStock: [
                {name: '非囤货', value: 0},
                {name: '囤货', value: 1}
            ],
            invoiceState: [
                {name: '无需开票', value: 0},
                {name: '未开票', value: 1},
                {name: '已开票', value: 2}
            ],
            invoiceFileType: [
                {name: '附件', value: 1},
                {name: '链接', value: 2},
                {name: '已开票', value: 2}
            ],
            orderClassify: [
                {name: '实物', value: 1},
                {name: '虚拟', value: 2}
            ],
            sendCompanyList: [],
            companyIdIndex: 1,
            rejectReason:''
        }
    },

    computed: {
        ...mapState(['systemConfig', 'userInfo']),
        orderType() {
            return (
                    [{
                        name: '普通',
                        value: 1
                    }, {
                        name: '赠品',
                        value: 3
                    }].concat(this.systemConfig.points_system == 'ON' ? [{
                        name: '积分',
                        value: 2
                    }] : [])
                            .concat(this.systemConfig.bargain_enabled == 'ON' ? [{
                                name: '砍价',
                                value: 4
                            }] : [])
                            .concat(this.systemConfig.presell_enabled == 'ON' ? [{
                                name: '预售订单(全款)',
                                value: 5
                            }] : [])
                            .concat(this.systemConfig.presell_enabled == 'ON' ? [{
                                name: '预售订单(定金)',
                                value: 6
                            }] : [])
                            .concat(this.systemConfig.product_custom == 'ON' ? [{
                                name: '定制',
                                value: 7
                            }] : [])
                            .concat([{
                                name: '拼团',
                                value: 8
                            }])
                            .concat(this.systemConfig.cloud_stock == 'ON' ? [{
                                name: '云仓提货',
                                value: 9
                            }] : [])
            );
        },
        defaultSearch() {
            let param = {
                check_state: [1],
            }
            return param;
        }
    },

    watch: {
    },

    mounted() {
        //搜索条件默认设置为：待审核
        this.$refs.searchForm.set(this.defaultSearch);
        this.$nextTick(() => {
            this.$refs.search.search();
        })
        this.$bus.$on('cash.order.update', data => {
            // 刷新列表
            this.$refs.table.update();
        });
    },


    methods: {
        //搜索
        searchHandle(data) {
            data.stationed_type = 1;
            data.is_cash_pay = 1;//仅查询转账支付订单
            this.searchDate = data;
            this.$refs.table.load({
                url: '/order/retail/list',
                data
            });
            this.searchParams = data || {};
        },
        /**
         * 审批
         * check_state = 2 通过
         * check_state = 3 驳回
         */
        batchApproved(check_state) {
			let data = this.$refs.table.getRow(item => item.data.checked).map(item => item.data.order_number);
            this._checkState = check_state;
            //批量操作
            if (!data.length) {
                this.$message({
                    text: '请选择需要审核的订单'
                });
                return;
            }
            //审核通过
            if (this._checkState == 2){
                this.$confirm({
                    text: '是否确认选中的“'+data.length+'条”订单已完成支付？审核通过即视为支付完成，该操作不可撤销。',
                    resolve: () => {
                        this.request({
                            url: '/order/check',
                            data: {
                                order_number_list: data,
                                check_state: this._checkState,
                                push_u8: 2
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: '订单审核通过成功'
                                });
                                // 刷新列表
                                this.$refs.table.update();
                                //数据清空
                            }
                        });
                    }
                });
            }else {
                //审核驳回
                this.rejectReason = '';
                this.$refs.rejectReason.open();
            }
        },
        //审核（提交数据）
        rejectHandle(stop) {
            stop();
			let data = this.$refs.table.getRow(item => item.data.checked).map(item => item.data.order_number);
            if (!this.rejectReason.trim()) {
                this.$message({
                    text: '请填写审核驳回原因'
                });
                return;
            }
            this.$confirm({
                text: '是否确认将选中的“'+data.length+'条”订单审核驳回，驳回后，订单将自动关闭。',
                resolve: () => {
                    this.request({
                        url: '/order/check',
                        data: {
                            order_number_list: data,
                            check_state:this._checkState,
                            reject_reason:this.rejectReason,
                            push_u8: 2
                        },
                        loading: true,
                        success: () => {
                            this.$message({
                                text: '订单审核驳回成功'
                            });
                            this.$refs.rejectReason.close();
                            // 刷新列表
                            this.$refs.table.update();
                            //数据清空
                        }
                    });
                }
            });
        }
    }
}
</script>
<style lang="stylus" scoped>
.order {
    &-verify {
        padding: 20px;

        textarea {
            box-sizing: border-box;
            width: 100%;
            height: 120px;
            border: none;
            padding: 10px 14px;
            line-height: 20px;
            background: #FAFAFA;
            resize: none;
        }
    }
}

.order {
    border: 1px solid #eee;
    margin: 16px 0;

    &-head {
        border-bottom: 1px solid #eee;
        padding: 6px 8px;
        line-height: 22px;
        font-size: 12px;
        background: #F8F8F8;

        .number {
            margin-left: 10px;
            color: #333;
        }

        .tag {
            align-self: center;
            border-radius: 2px;
            padding: 0 5px;
            margin-left: 6px;
            line-height: 18px;
            color: #fff;
        }

        .info {
            position: relative;
            padding-left: 10px;
            white-space: nowrap;
            color: #999;

            &:nth-child(n+2) {
                &:after {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 3px;
                    height: 16px;
                    border-left: 1px solid #999;
                }

                margin-left: 10px;
            }
        }
    }

    &-product {
        flex-grow: 790;
        flex-basis: 790px;

        .sku {
            &:nth-child(n+2) {
                border-top: 1px solid #eee;
            }

            &-info {
                flex-grow: 400;
                flex-basis: 400px;
                box-sizing: border-box;
                padding: 10px 0 10px 14px;
            }

            &-image {
                width: 80px;
                height: 80px;
                margin-right: 24px;
            }

            &-name {
                font-size: 12px;
                color: #666;
            }

            &-sku {
                margin-top: 10px;
                font-size: 12px;
            }

            &-price,
            &-code,
            &-count {
                flex-grow: 130;
                flex-basis: 130px;
                font-size: 13px;
                text-align: center;
                color: #333;
            }
        }
    }

    &-sum,
    &-state,
    &-handle {
        flex-grow: 170;
        flex-basis: 170px;
        box-sizing: border-box;
        border-left: 1px solid #eee;
    }

    &-sum {
        line-height: 20px;
        font-size: 12px;
        text-align: center;
        color: #333;

        span {
            color: #888;
        }
    }

    &-state {
        line-height: 20px;
        font-size: 12px;

        a {
            color: #0060EF;
        }
    }

    &-handle {
        padding: 10px 0;

        .c-button {
            width: 6em;

            &:nth-child(n+2) {
                margin-top: 8px;
            }
        }
    }

    &-remark {
        padding: 20px;

        textarea {
            box-sizing: border-box;
            width: 100%;
            height: 200px;
            border: none;
            padding: 10px 14px;
            line-height: 20px;
            background: #FAFAFA;
            resize: none;
        }
    }
}

.invoice {
    padding: 5px 10px;
    box-sizing: border-box;

    p {
        font-weight: bold;
        margin-bottom: 30px;
        font-size: 15px;
    }
}
</style>